export default __webpack_public_path__ + "static/media/PlantillaPersonalEscuela2.cfa192df.jpeg";